import api from '@edu-fe/api'
import assign from 'lodash.assign'
import comment from './comment'
import global from '../types/global.types'
import login from '@/utils/login'
import os from '@edu-fe/os'

export default {
  name: 'audio-detail',
  namespaced: true,
  modules: {
    comment
  },
  state () {
    return {
      dataSource: {}, // 媒体数据
      signStatus: 0, // 签到状态 -1: 不需要签到 0: 未签到 1: 已签到
      clockInStatus: {},
      // 是否是畅学卡用户
      buyCardFlag: true,
      hasBuy: 0,
      isVisible: true,
      currentChapterIndex: 0,
      chapterList: [],
      quickChapterList: []
      // isSendNotify: 1, //弹窗状态 0 未发过 1 已发
      // isSign: 0,  // 0 未打卡 1 已打卡
      // isSignCourse: 0,  // 0 课程不支持打卡 1 支持
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },
    setData: (state, data) => (state.dataSource = data),
    addData: (state, data) => (assign(state.dataSource, data)),
    setSignStatus: (state, data) => (state.signStatus = data),
    setClockInStatus: (state, data) => (state.clockInStatus = data),
    setQuickList: (state, { data, chapterId }) => {
      data.forEach((item, index, el) => {
        if (chapterId === item.id) {
          state.currentChapterIndex = index
          state.quickChapterList = [
            el[index - 1],
            el[index + 1]
          ]
        }
      })
    },
    setChapterList: (state, { chapterList, hasBuy }) => {
      chapterList = chapterList.filter((item) => {
        if (item.type === 1) {
          return false
        }
        return true
      })
      state.chapterList = chapterList
      state.hasBuy = hasBuy
    }
  },
  actions: {
    async checkLogin () {
      const wpsSid = await login.getWpsSid()

      return wpsSid || login.login()
    },
    // 获取媒体信息
    async getMediaData ({ commit, dispatch }, { chapterId, stage, resolution, _this }) {
      _this.$loading.show()

      const { data } = await api.media.getMediaData({
        chapterId,
        resolution,
        stage,
        client: os.type === 'ali' ? 1 : ''
      })

      if (data.canTry !== 1) {
        await dispatch('checkLogin')
      }
      _this.$loading.hide()
      if (!data.content) {
        data.content = `<img class="audio-detail-content-null" src=${require('../assets/images/audio-detail-null.png')}>`
      }
      commit('setData', data)
    },

    // 获取签到状态
    async checkSignStatus ({ commit }, { chapterId, courseId }) {
      const { data } = await api.media.checkSignStatus({ chapterId, courseId })
      commit('setSignStatus', data)
    },

    // 签到
    async sign ({ commit }, { chapterId, courseId }) {
      const { data } = await api.media.sign({ chapterId, courseId })
      commit('setSignStatus', data)
      data === 1 && commit(global.ERR, '签到成功', { root: true })
    },

    // 获取签到状态
    async getClockState ({ commit }, { chapterId }) {
      const { data } = await api.clockIn.getClockState({ chapterId })
      commit('setClockInStatus', data)
      commit('set', { isVisible: false })
    },

    // 获取用户信息，其中的 userId 在分享时候要用
    // async getUserInfo ({ commit, rootState }) {
    //   commit('addData', { userId: rootState.userInfo.userId })
    // },

    // 初始化
    async init ({ state, dispatch, rootState: { route: { query: { courseId, chapterId } } } }, _this) {
      await dispatch('getMediaData', { chapterId, _this })
      // await dispatch('checkSignStatus', { courseId, chapterId })
      await dispatch('getUserInfo', null, { root: true })
      await dispatch('getClockState', { chapterId })
      dispatch('getSchedule', { courseId, chapterId })
      dispatch('comment/initComment', { wid: chapterId })
      dispatch('getPrivilege', null, { root: true })
    },
    async getSchedule ({ commit, state }, { courseId, chapterId }) {
      const { data } = await api.schedule.getData({ courseId, position: 1 })
      if (state.dataSource.isRadioCourse) {
        data.chapterList.reverse()
      }
      commit('setChapterList', { chapterList: data.chapterList, hasBuy: data.isBuy })
      commit('setQuickList', { data: state.chapterList, chapterId })
    },
    async changeQuickList ({ commit, state }, { chapterId }) {
      commit('setQuickList', { data: state.chapterList, chapterId })
    }
  }
}
